import { every } from './_common';

export default [
  ...every,
  {
    text: 'Проекты',
    icon: 'mdi-apps',
    to: '/project-settings',
    order: 2,
  },
  {
    icon: 'mdi-account-group-outline',
    text: 'Пользователи',
    to: '/users',
    order: 5,
  },
  {
    text: 'Автоответы',
    icon: 'mdi-alert-box-outline',
    to: '/answer-settings',
    order: 4,
  },
  {
    text: 'Експорт',
    icon: 'mdi-alert-box-outline',
    to: '/export',
    order: 7,
  },
  {
    text: 'Мониторинг',
    icon: 'mdi-monitor-eye',
    order: 6,
    children: [
      {
        text: 'Обработанные письма',
        icon: 'mdi-message-text-outline',
        to: '/letter-handler',
      },
      {
        text: 'Ошибки пользователей',
        icon: 'mdi-close',
        to: '/users-errors',
      },
    ],
  },
];
